import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ToastrService } from 'ngx-toastr';
import { Product } from '../classes/product';
import { BehaviorSubject, Observable, of, Subscriber } from 'rxjs';
import { map, filter, scan } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/empty'


// Get product from Localstorage
let products = JSON.parse(localStorage.getItem("compareItem")) || [];

@Injectable(
  { providedIn: 'root' }
)

export class ProductsService {
  private _companyName = '';
  public currency: string = 'USD';
  public catalogMode: boolean = false;
  private _companyData: any;
  public compareProducts: BehaviorSubject<Product[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;
  private _bannerMessage = '';

  // Initialize 
  constructor(private http: Http, private toastrService: ToastrService) {
    this.compareProducts.subscribe(products => products = products);
  }
  public get companyName() {
    return this._companyName;
  }
  public set companyName(value) {
    this._companyName = value;
  }
  public get companyData(): any {
    return this._companyData;
  }
  public set companyData(value: any) {
    this._companyData = value;
  }
  public get bannerMessage() {
    return this._bannerMessage;
  }
  public set bannerMessage(value) {
    this._bannerMessage = value;
  }


  // Observable Product Array
  private products(): Observable<Product[]> {
    //console.log('Print:' + this.http.get('assets/data/products.json').map((res:any) => res.json())); 
    return this.http.get('assets/data/products.json').map((res: any) => res.json())
  }
  private products_details(): Observable<Product[]> {
    //console.log('Print:' + this.http.get('assets/data/products.json').map((res:any) => res.json())); 
    return this.http.get('assets/data/products.json').map((res: any) => res.json())
  }

  // Get Products
  public getProducts(): Observable<Product[]> {
    return of([] as Product[]);;
  }

  // Get Products By Id
  public getProduct(id: number): Observable<Product> {
    return this.products().pipe(map(items => { return items.find((item: Product) => { return item.id === id; }); }));
  }

  // Get Products By category
  public getProductByCategory(category: string): Observable<Product[]> {
    return this.products().pipe(map(items =>
      items.filter((item: Product) => {
        if (category == 'all')
          return item
        else
          return item.category === category;

      })
    ));
    //return '';
  }

  /*
     ---------------------------------------------
     ----------  Compare Product  ----------------
     ---------------------------------------------
  */

  // Get Compare Products
  public getComapreProducts(): Observable<Product[]> {
    const itemsStream = new Observable(observer => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // If item is aleready added In compare
  public hasProduct(product: Product): boolean {
    const item = products.find(item => item.id === product.id);
    return item !== undefined;
  }

  // Add to compare
  public addToCompare(product: Product): Product | boolean {
    var item: Product | boolean = false;
    if (this.hasProduct(product)) {
      item = products.filter(item => item.id === product.id)[0];
      const index = products.indexOf(item);
    } else {
      if (products.length < 4)
        products.push(product);
      else
        this.toastrService.warning('Maximum 4 products are in compare.'); // toasr services
    }
    localStorage.setItem("compareItem", JSON.stringify(products));
    return item;
  }

  // Removed Product
  public removeFromCompare(product: Product) {
    if (product === undefined) { return; }
    const index = products.indexOf(product);
    products.splice(index, 1);
    localStorage.setItem("compareItem", JSON.stringify(products));
  }


}